import React from 'react'
import { AppModal, AppTableSkeleton } from '@components'
import { Table, TableBody, TableCell, TableHead, TableRow, Typography, Box } from '@mui/material'
import { scraperSiteSelected } from 'Pages/Admin/GlobalExecution/@signals'
import { useScraperUserSearches } from './@hooks'
import { dsColorNew } from '@palette'

export default function ScraperUserSearchesModal() {
	const { data, isLoading, siteName, onClose } = useScraperUserSearches()

	return <AppModal
		icon="users"
		title={`Searches per user — ${siteName}`}
		containerProps={{ maxWidth: 'sm' }}
		isOpen={scraperSiteSelected.value !== null}
		controller={onClose}
		hideActions
	>
		{isLoading
			? <AppTableSkeleton rows={4} columns={2}/>
			: data.length === 0
				? <Typography color={dsColorNew.textMuted} textAlign="center" py={2}>No data</Typography>
				: <Box sx={{ overflowX: 'auto' }}>
					<Table size="small" sx={{ '& .MuiTableBody-root .MuiTableCell-root': { color: dsColorNew.textDark } }}>
						<TableHead>
							<TableRow>
								<TableCell sx={{ fontWeight: 'bold' }}>User</TableCell>
								<TableCell sx={{ fontWeight: 'bold' }} align="right">Searches</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{data.map((row, i) => (
								<TableRow key={i} hover>
									<TableCell>{row.userName}</TableCell>
									<TableCell align="right">{row.searches}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</Box>
		}
	</AppModal>
}